












































import Vue from 'vue'
import Component from 'vue-class-component'
import moduleStore from '../index/store'
import { Toast  } from 'vant'
import Clipboard from 'clipboard'
import Cookies from 'js-cookie'
import openAppByBtn from '../../utils/open-download-app'

@Component({})
@moduleStore.initVuex({
	mutationNames: moduleStore.mutationNames,
	actionNames: moduleStore.actionNames
})
export default class vipWechatPay extends Vue {
  phone: string = ''
  title: string = ''
  rightsNum: number = 0
  // 是否为 IOS
  isIOS: boolean = false
  mounted() {
    openAppByBtn()
    // 判断当前是否为 iOS 环境
    this.isIOS = /(iPhone|iPad|iPod|iOS|mac os)/i.test(navigator.userAgent)
    // 读取传过来的手机号
    this.phone = this.$route.query.phone as string || ''
    // 读取传过来的套餐时间
    this.title = this.$route.query.title as string || ''
    const vipTime = (this.$route.query.vipTime as string) || "";
    const isOnlyVip = (this.$route.query.isOnlyVip as string) || "";
    this.rightsNum =
      +this.$route.query.rightsNum ||
      (parseInt(vipTime) >= 12 || isOnlyVip == "0" ? 10 : 9);
    // 剪切
    this.$nextTick(() => {
      // 微信小程序
      const clipboardWechat = new Clipboard('#moyin-wechat', {
        text: () => '魔音工坊配音助手'
      })
      clipboardWechat.on('success', function() {
        Toast({
          message: "已复制小程序名称「魔音工坊配音助手」，请前往微信搜索进行使用",
          icon: "success",
          duration: 2000,
          position: 'top'
        })
      })
      // pc
      const clipboardPC = new Clipboard('#moyin-pc', {
        text: () => 'https://www.moyin.com/'
      });
      clipboardPC.on('success', function() {
        Toast({
          message: "已复制链接，请在电脑端打开",
          icon: "success",
          duration: 2000,
          position: 'top'
        })
      })
      // app
      const clipboardApp = new Clipboard('#moyin-app', {
        text: () => 'https://mobvoi-backend-public.ticwear.com/moyin/apk/moyin_release_official_23.2.3_20220505.apk'
      });
      clipboardApp.on('success', function() {
        Toast({
          message: "已复制APP下载地址，请前往浏览器中打开进行下载使用",
          icon: "success",
          duration: 2000,
          position: 'top'
        })
      })
    })
  }
  /**
   * 继续购买
   */
  buyAgain() {
    const channelCode = Cookies.get('CHANNEL_CODE') || ''
    this.$router.push({
      path: '/vipWechatPay',
      query: {
        channelCode
      }
    })
  }
}

